import { Fragment, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import LabHolidayList from "./LabHolidayList";
import TokenService from "../../../../Services/Token.service";
import LabHoursList from "./LabHoursList";
import { Helmet } from "react-helmet";
import ClearFilterButton from "../../../../Components/ClearFilterButton";

function LabManagement() {

    const navigate = useNavigate();
    const previousUrl = TokenService.getPrevLink();
    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0);

    const [isHolidayClearFilter, setIsHolidayClearFilter] = useState(false);
    const [filterHolidayCount, setHolidayFilterCount] = useState(0);

    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };

    const handleHolidayClearFilters = () => {        
        setIsHolidayClearFilter(true);
        setTimeout(() => setIsHolidayClearFilter(false), 0);
    };


    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };

    const handleHolidayFilterCountChange = (count) => {
        setHolidayFilterCount(count); // Update filter count
    };

    return (
        <>
            <Fragment>
            <Helmet>
                <title>DonorX | Lab Hours</title>
            </Helmet>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">Lab Hours</h2>
                    <Link className="back-link" to={`/admin/administrative-settings`}><i className='el-icon-back'></i> Administrator Settings</Link>
                    {/* className={`${totalHoliday>3 ? 'morethan-3' : 'lessthan-3'} el-bg-table `} */}
                    

                    <div className="el-bg-table">   
                        <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                                {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
                            </div>
                            <div>
                                <button onClick={() =>{ TokenService.updatePrevLink('/admin/lab-hours'); navigate(`/admin/lab-hours/add`)}} className="el-main-button me-0"> <span><i className="el-icon-add"></i>  Add Lab</span></button>
                            </div>
                        </div> 
                        <>
                           <LabHoursList isClearFilter={isClearFilter} onFilterCountChange={handleFilterCountChange}/>
                        </>
                    </div>
                </div>

                <div className="el-middle-wrapper">
                    <div className="el-bg-table">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <h3>Vacation List</h3> &nbsp;&nbsp;&nbsp;&nbsp;
                                {filterHolidayCount > 0 && (<ClearFilterButton handleClearFilters={handleHolidayClearFilters} />)}
                                {filterHolidayCount > 0 && (<span className="m-2">Filters applied: {filterHolidayCount}</span>)}
                            </div>    
                            <div className="d-flex justify-content-around">
                                <button onClick={() =>{TokenService.updatePrevLink('/admin/lab-hours'); navigate(`/admin/lab-hours/lab-holiday/add`)}} className="el-main-button me-0"> <span><i className="el-icon-add"></i> Add Vacation</span> </button>                                
                            </div>                        
                        </div>
                        <>
                           <LabHolidayList isClearFilter={isHolidayClearFilter} onFilterCountChange={handleHolidayFilterCountChange}/>
                        </>
                    </div>
                </div>

            </Fragment>
        </>
    );
}

export default LabManagement;